import { AttendeeRequest } from "../../interfaces/identity/calendar/Events";

/**
 * Transforms legacy arrays into the unified attendee model required by Calendar 2.0
 */
export const mapToUnifiedAttendees = (
  participantIds: string[] = [],
  externalEmails: string[] = []
): AttendeeRequest[] => {
  const attendees: AttendeeRequest[] = [];

  // Map internal participants (Logic: numeric strings are Waiver Participants)
  participantIds.forEach((id) => {
    if (id) {
      attendees.push({
        type: /^\d+$/.test(id) ? "WAIVER_PARTICIPANT" : "EMPLOYEE",
        ref: id,
      });
    }
  });

  // Map external guests
  externalEmails.forEach((email) => {
    // Ensure email is a valid, non-undefined, non-null string
    const cleanEmail = email ? String(email).trim().toLowerCase() : null;
    if (cleanEmail && cleanEmail !== 'undefined' && cleanEmail !== 'null') {
      attendees.push({
        type: "EXTERNAL",
        email: cleanEmail,
      });
    }
  });

  return attendees;
};